<template>
  <div id="tab">
    <slot> </slot>
  </div>
</template>

<script>
export default {
  props: {},
  data() {
    return {};
  },
  computed: {},
  created() {},
  mounted() {},
  watch: {},
  methods: {},
  components: {},
};
</script>

<style lang="less" scoped>
#tab {
  display: flex;
  margin-left: 1rem;
}
</style>
